import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'portfolio-3-portfolio.common.project-exceed-limit-error-page.header',
		defaultMessage: 'This plan contains too many projects',
		description: 'Title for error page when plan has too many projects',
	},
	errorDescription: {
		id: 'portfolio-3-portfolio.common.project-exceed-limit-error-page.error-description',
		defaultMessage: 'Ask the plan owner to reduce the number of projects in this plan.',
		description: 'Description explaining why an error page is shown',
	},
	openPlanInJira: {
		id: 'portfolio-3-portfolio.common.project-exceed-limit-error-page.open-plan-in-jira',
		defaultMessage: 'Open plan in Jira',
		description: 'Text on button to open the plan in Jira',
	},
});
